export default "__VITE_ASSET__Bh$FKxo___"